import { useRouter } from 'next/router';
// components
import BothHeader from 'components/layout/headers/Both';
import IconButton from 'cds/buttons/Icon';
import Icon from 'cds/icons';
// hooks
import useCommonBridge from 'hooks/bridge/useCommonBridge';
import useSearchModal from 'hooks/common/useSearchModal';

/**
 * 검색 버튼 헤더
 * @param {object} props
 * @param {string} props.title 제목
 * @param {Function} props.onBack 뒤로가기 버튼 클릭 함수
 */
const BackSearchHeader = ({ title, onBack }) => {
  const router = useRouter();

  const { onCloseWebView } = useCommonBridge();
  const { onOpenSearch } = useSearchModal();

  const onBack_ = onBack
    ? onBack()
    : () => {
        if (!onCloseWebView()) {
          router.back();
        }
      };

  return (
    <BothHeader
      message={title}
      leftSide={
        <IconButton width={24} height={54} onClick={onBack_}>
          <Icon name="ic_back_m" width={24} height={24} />
        </IconButton>
      }
      rightSide={
        <IconButton width={24} height={54} onClick={onOpenSearch}>
          <Icon name="ic_search" width={24} height={24} />
        </IconButton>
      }
    />
  );
};

export default BackSearchHeader;
